module.exports = __webpack_public_path__ + "static/media/weatherbundle-image.df0fc30d.PNG";